"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resolveReport = exports.filterCompletedReports = void 0;
const monocle = require("monocle-ts");
const sok_types_1 = require("@caddigital/sok-types");
const filterCompletedReports = ({ payload }) => payload.status === sok_types_1.Reports.COMPLETED;
exports.filterCompletedReports = filterCompletedReports;
const findReport = (reportUuid) => (report) => report.uuid === reportUuid;
const reportState = monocle.Lens.fromPath(['value', 'reports', 'reportList', 'reports']);
const resolveReport = (store) => ({ payload }) => reportState.get(store).find(findReport(payload.reportUuid));
exports.resolveReport = resolveReport;
//# sourceMappingURL=file.js.map